import React, { useMemo, useState } from "react";
import {
    Box,
    Skeleton,
    styled,
    Table,
    TableBody,
    TableContainer,
    TableHead,
    TableRow,
    TableSortLabel,
    Paper,
    IconButton,
    Collapse,
    Typography,
    Card,
    CardContent,
    Stack,
    LinearProgress,
} from "@mui/material";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { KeyboardArrowRight } from "@mui/icons-material";
import { FaHourglassHalf } from "react-icons/fa";
import { Gantt, ViewMode } from "gantt-task-react";
import "gantt-task-react/dist/index.css";
import moment from "moment";
// import Highcharts, { color } from "highcharts";
// import HighchartsReact from "highcharts-react-official";
// import xrange from "highcharts/modules/xrange";
// import more from "highcharts/highcharts-more";

// if (typeof more === "function") {
//     more(Highcharts);
//     xrange(Highcharts);
// }



const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        padding: "8px 10px",
        fontSize: 13,
        fontWeight: 700,
        backgroundColor: "#F9FAFB",
        borderRight: "1px solid #e0e0e0",
        borderBottom: "1px solid #e0e0e0",
        color: "#374151",
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 12,
        padding: "6px 10px",
        borderRight: "1px solid #f3f4f6",
        color: "#4B5563",
    },
}));

const rotationStyle = {
    "@keyframes spin": {
        "0%": { transform: "rotate(0deg)" },
        "100%": { transform: "rotate(360deg)" },
    },
};

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:last-child td, &:last-child th": {
        border: "0 !important",
    },
}));

const toUTC = (dateStr) => {
    if (!dateStr) return null;

    const [day, month, year] = dateStr.split("/").map(Number);
    return new Date(year, month - 1, day); // month is 0-based
};

/* const GanttChartOld = ({ data, parent }) => {
    

    const options = {
        title: {
            text: "",
            align: "left"
        },
        xAxis: {
            units: [
                ["month", [1]] // one label per month
            ],
            labels: {
                format: "{value:%b %Y}"
            }
        },
        // xAxis: {
        //     min: Date.UTC(2014, 10, 17), // Month is 0-based
        //     max: Date.UTC(2014, 10, 30)
        // },
        credits: { enabled: false },
        accessibility: {
            point: {
                descriptionFormat:
                    "{yCategory}. " +
                    "{#if completed}Task {(multiply completed.amount 100):.1f}% " +
                    "completed. {/if}" +
                    "Start {x:%Y-%m-%d}, end {x2:%Y-%m-%d}."
            }
        },

        lang: {
            accessibility: {
                axis: {
                    xAxisDescriptionPlural:
                        "The chart has a two-part X axis showing time in both week numbers and days."
                }
            }
        },

        series: [
            {
                name: "Project 1",
                type: "gantt",
                data: data.map((t) => ({
                    id: t?.id,
                    name: t?.activity,
                    start: toUTC(t?.baselineStart),
                    end: toUTC(t?.baselineFinish),
                    color: '#38BDF8',
                    completed: {
                        amount: t?.actualPercent / 100
                    },
                })),
            }
        ]
    };

    return (
        <Box sx={{ width: "100%", overflowX: "auto" }}>
            <Typography fontSize={12} fontWeight={600} mb={1}>
                Timeline for: {parent.name}
            </Typography>

            <Box
                sx={{
                    // height: 80,
                    backgroundColor: "#EEF2FF",
                    borderRadius: 1,
                    // display: "flex",
                    // alignItems: "center",
                    px: 2,
                    fontSize: 12,
                    color: "#374151",
                }}
            >
                <HighchartsReact
                    highcharts={Highcharts}
                    constructorType="ganttChart"
                    options={options}
                />
            </Box>
        </Box>
    );
}; */
const formatDate = (date) =>
    date.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric"
    });

const TaskListTable = ({ tasks }) => (
    <>
        {tasks.map((task, index) => (
            <div
                key={task?.id}
                style={{
                    display: "grid",
                    gridTemplateColumns: "1fr",
                    height: "50px",
                    fontSize: 14,
                    backgroundColor: index % 2 === 0 ? "#ffffff" : "#f5f5f5",
                    // borderBottom: "2px solid #f3f4f6",
                    alignItems: "center",
                    justifyContent: 'center',
                    padding: "0 8px"
                }}
            >
                {/* <div>{task?.name}</div> */}
                {/* <div>{formatDate(task?.start)}</div>
                <div>{formatDate(task?.end)}</div> */}
            </div>
        ))}
    </>
);
const TaskListHeader = ({ tasks }) => (
    <>

        <div
            // key={task?.id}
            style={{
                display: "grid",
                gridTemplateColumns: "1fr",
                height: "50px",
                fontSize: 14,
                // backgroundColor: index % 2 === 0 ? "#ffffff" : "#f5f5f5",
                border: "2px solid #f3f4f6",
                alignItems: "center",
                justifyContent: 'center',
                padding: "0 8px"
            }}
        >
            {/* <div>Name</div> */}
        </div>
    </>
);

const GanttTooltipCard = ({ task }) => {


    return (
        <Card
            elevation={4}
            sx={{
                // minWidth: 220,
                borderRadius: 2,
                backgroundColor: "#ffffff",
                padding: 1
            }}
        >
            <CardContent sx={{ padding: "12px !important" }}>
                <Stack spacing={1}>
                    <Typography fontWeight={600} sx={{ m: 0, p: 0, lineHeight: 0 }}>
                        {task?.shortName}
                    </Typography>
                    <Typography variant="caption" color="text.secondary" sx={{ margin: 0, padding: 0 }}>
                        {task?.asset}
                    </Typography>

                    <Typography variant="caption" color="text.secondary">
                        {moment(task.start.toDateString())?.format('DD/MM/YYYY')}{" "}
                        {task.end && `– ${moment(task.end.toDateString())?.format('DD/MM/YYYY')}`}
                    </Typography>
                    <Typography variant="caption" sx={{ m: 0, p: 0, lineHeight: 1 }}>
                        Progress: {task.progress}%
                    </Typography>
                    <Typography variant="caption" sx={{ m: 0, p: 0, lineHeight: 1 }}>
                        Total Unit: {task?.totalUnits}
                    </Typography>
                    <Typography variant="caption" sx={{ m: 0, p: 0, lineHeight: 1 }}>
                        Work Done: {task?.workDone}
                    </Typography>
                    <Typography variant="caption" sx={{ m: 0, p: 0, lineHeight: 1 }}>
                        Remaining Unit: {task?.remainingUnits}
                    </Typography>

                </Stack>
            </CardContent>
        </Card>
    );
};


const GetGanttChart = ({ data, parent }) => {

    const [view, setView] = useState(ViewMode.Month);

    // const tasks = data?.map((task) => ({
    //     id: task?.id,
    //     name: task?.activity,
    //     progress: task?.actualPercent?.toFixed(2),
    //     type: "task",
    //     project: "project-1",
    //     start: toUTC(task?.baselineStart),
    //     end: toUTC(task?.baselineFinish),
    // }))
    // 

    return (
        <Box sx={{ width: "100%" }}>
            <Typography fontSize={12} fontWeight={600} mb={1}>
                Activities:-
            </Typography>


            {data?.length > 0 &&
                <Gantt
                    tasks={data?.map((task) => ({
                        id: task?.id,
                        name: task?.activity,
                        shortName: task?.shortName,
                        asset: task?.asset,
                        totalUnits: task?.totalUnits,
                        workDone: task?.workDone,
                        remainingUnits: task?.remainingUnits,
                        progress: task?.actualPercent?.toFixed(2),
                        type: "task",
                        project: "project-1",
                        start: toUTC(task?.baselineStart),
                        end: toUTC(task?.baselineFinish),
                        styles: {
                            backgroundColor: "grey",
                            progressColor: "#38BDF8",
                            // progressSelectedColor: "#16a34a"
                        },
                    }))}
                    TaskListTable={TaskListTable}
                    TaskListHeader={TaskListHeader}
                    viewMode={view}
                    listCellWidth="190px"
                    columnWidth={80}
                    barLabelWidth={0}
                    // rowHeight=
                    TooltipContent={({ task }) => (
                        <div style={{
                            marginTop: 40,
                            
                            position: "relative",
                            zIndex: 9999
                        }}>
                            <GanttTooltipCard task={task} />
                        </div>
                    )}

                // TooltipContent={({ task }) => (
                //     <div style={{ padding: 15, backgroundColor: '#fff' }}>
                //         <strong style={{ fontSize: '18px' }}>{task.name}</strong>
                //         <br />
                //         {moment(task.start.toDateString())?.format('DD/MM/YYYY')} – {moment(task?.end?.toDateString())?.format('DD/MM/YYYY')}
                //         <br/>
                //         <strong>Progress:-</strong> {`${task?.progress}%`}
                //     </div>
                // )}
                // locale={enIN}
                />
            }
        </Box>
    );
}

const CollapsibleRow = ({
    row,
    columns,
    stickyLeftByIndex,
    level = 0,
    handleClick,
    loaderId,
    isGantt
}) => {


    const [open, setOpen] = useState(false);
    const hasChildren = row.hasChildren || false;
    const isLoading = loaderId === row.id;
    const handleToggle = (e) => {
        e.stopPropagation();
        if (!open && row.hasChildren === true) {
            handleClick(row);
        }
        setOpen(!open);
    };

    return (
        <>
            <TableRow
                sx={{
                    backgroundColor:
                        level === 0
                            ? "white"
                            : "#FCFCFD", // child rows slightly tinted
                    "&:nth-of-type(odd)": {
                        backgroundColor: level === 0 ? "#FFFFFF" : "#F9FAFB",
                    },
                    "&:hover": { backgroundColor: "#EEF2FF" },
                }}
            >
                {columns.map((col, ind) => (
                    <StyledTableCell
                        key={`${col.name}-${ind}`}
                        align={col.align || "right"}
                        sx={{
                            boxSizing: "border-box",
                            whiteSpace: "normal",
                            minWidth: col.width || 120,
                            backgroundColor: col.sticky
                                ? level > 0
                                    ? "#F9FAFB"
                                    : "#F9FAFB"
                                : "inherit",
                            zIndex: col.sticky ? 2 : 1,
                            fontWeight: level === 0 && ind === 0 ? 600 : 400,
                            ...(col.sticky && {
                                position: "sticky",
                                left: stickyLeftByIndex[ind] || 0,
                            }),
                            padding: col.padding === 0 ? "0 !important" : "6px 10px",
                            height: "1px",
                        }}
                    >
                        {ind === 0 ? (
                            <Box
                                sx={{ display: "flex", alignItems: "center", ml: level * 1.5 }}
                            >
                                {hasChildren ? (
                                    <IconButton
                                        size="small"
                                        onClick={handleToggle}
                                        sx={{ p: 0, mr: 0.5, width: "24px" }}
                                    >
                                        {isLoading ? (
                                            <FaHourglassHalf
                                                style={{ fontSize: "14px", color: "#6B7280" }}
                                                sx={{
                                                    animation: "spin 1.5s linear infinite",
                                                    ...rotationStyle,
                                                }}
                                            />
                                        ) : open ? (
                                            <KeyboardArrowDownIcon fontSize="small" />
                                        ) : (
                                            <KeyboardArrowRight fontSize="small" />
                                        )}
                                    </IconButton>
                                ) : (
                                    <Box sx={{ width: 18 }} />
                                )}
                                {col.renderer ? col.renderer(row) : row[col.field]}
                            </Box>
                        ) : col.renderer ? (
                            col.renderer(row)
                        ) : (
                            row[col.field]
                        )}
                    </StyledTableCell>
                ))}
            </TableRow>
            {hasChildren && open && isGantt && (
                <TableRow>
                    <TableCell
                        colSpan={columns.length}
                        sx={{
                            p: 1.5,
                            backgroundColor: "#F9FAFB",
                            borderBottom: "1px solid #E5E7EB",
                        }}
                    >
                        {/* Your Gantt Chart Component */}
                        <GetGanttChart
                            data={row.children}
                            parent={row}
                        />
                    </TableCell>
                </TableRow>
            )}
            {hasChildren &&
                open && !isGantt &&
                row?.children?.map((child, i) => (
                    <CollapsibleRow
                        key={child.id || i}
                        row={child}
                        columns={columns}
                        stickyLeftByIndex={stickyLeftByIndex}
                        level={level + 1}
                        handleClick={handleClick}
                        loaderId={loaderId}
                    />
                ))}
        </>
    );
};

const NestedTableComponent = ({
    data,
    columns,
    months = [],
    handleClick,
    loaderId,
    isGantt,
}) => {
    const stickyLeftByIndex = [];
    let runningLeft = 0;
    columns?.forEach((col, index) => {
        if (col.sticky) {
            stickyLeftByIndex[index] = runningLeft;
            let w =
                typeof col.width === "string"
                    ? parseInt(col.width, 10)
                    : col.width || 150;
            runningLeft += w;
        }
    });

    const monthColumnCount = columns?.filter((c) => c.type === "month").length || 0;
    const stickyColumnCount = columns?.filter((c) => c.sticky).length || 0;
    const extraStaticCount =
        columns.length - (stickyColumnCount + monthColumnCount);
    // 
    return (
        <TableContainer
            component={Paper}
            sx={{
                maxWidth: "100%",
                overflowX: "auto",
                maxHeight: "85vh",
                display: "block",
                position: "relative",
                border: "1px solid #e5e7eb",
                width: '100%',
                pb: 2
            }}
        >
            <Table stickyHeader size="small">
                <TableHead sx={{ position: "sticky", top: "0px", zIndex: 100 }}>
                    {months.length > 0 && <TableRow>
                        <StyledTableCell
                            colSpan={stickyColumnCount}
                            sx={{ position: "sticky", left: 0, zIndex: 10 }}
                        ></StyledTableCell>
                        <StyledTableCell
                            colSpan={extraStaticCount}
                            sx={{
                                zIndex: 10,
                                backgroundColor: "#F9FAFB",
                                textAlign: "center",
                            }}
                        ></StyledTableCell>
                        {months?.length > 0 && months?.map((month, index) => (
                            <StyledTableCell
                                key={month.month}
                                colSpan={month.span}
                                align="center"
                                sx={{ borderLeft: "2px solid #fff", backgroundColor: index % 2 == 0 ? "#238ccb !important" : "#1a6998 !important", color: "white !important" }}
                            >
                                {month.month}
                            </StyledTableCell>
                        ))}
                    </TableRow>}

                    <TableRow>
                        {columns?.map((col, index) => (
                            <StyledTableCell
                                key={`${col.name}-${index}`}
                                align={col.align || "left"}
                                sx={{
                                    width: col.width || 80,
                                    minWidth: col.width || 80,
                                    zIndex: col.sticky ? 11 : 1,
                                    ...(col.sticky && {
                                        position: "sticky",
                                        left: stickyLeftByIndex[index] || 0,
                                    }),
                                    boxSizing: "border-box",
                                    lineHeight: "125%",
                                }}
                            >
                                {col.name}
                            </StyledTableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.length > 0 ? (
                        data.map((row, index) => (
                            <CollapsibleRow
                                key={row?.id || index}
                                row={row}
                                columns={columns}
                                stickyLeftByIndex={stickyLeftByIndex}
                                handleClick={handleClick}
                                loaderId={loaderId}
                                isGantt={isGantt}
                            />
                        ))
                    ) : (
                        <StyledTableRow>
                            <StyledTableCell colSpan={columns?.length}>
                                Record not found.
                            </StyledTableCell>
                        </StyledTableRow>
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default NestedTableComponent;
